import { queryOptions } from "@tanstack/react-query";
import { listPublishedCmsArticles } from "./cmsArticles.functions";

export const publishedArticlesQuery = queryOptions({
  queryKey: ["cms-articles", "published"],
  queryFn: () => listPublishedCmsArticles(),
  staleTime: 60_000,
});